import { render, staticRenderFns } from "./ClaimDateQuestion.vue?vue&type=template&id=f310a62c&scoped=true"
import script from "./ClaimDateQuestion.vue?vue&type=script&lang=ts"
export * from "./ClaimDateQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ClaimDateQuestion.vue?vue&type=style&index=0&id=f310a62c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f310a62c",
  null
  
)

export default component.exports